import { LngLatBoundsLike, LngLatLike } from 'mapbox-gl';

export const config = Object.freeze({
    container: 'map',
    zoom: 6.2,
    center: [11.166863432084483, 56.0865080288055] as LngLatLike,
    accessToken: 'pk.eyJ1Ijoia29wb2drYW5kZSIsImEiOiJja3Q4bjZpOWExNDExMnZwZXM1MmZyYzU1In0.-CA6oc06yep4e1p8auWEuw',
    style: 'mapbox://styles/kopogkande/ckta28kjq6h8t17phk58dq4eu'
});

export const dkBounds = [
    [12.937614719453801, 54.74812241620551],
    [7.631724551348057, 57.89087401174404]
] as LngLatBoundsLike;
